import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    inject,
    Input,
    OnInit,
    ViewEncapsulation,
} from "@angular/core";
import { LineItem, PricingOccurrence } from "../../../../pojo/Pricing";
import { Table } from "../../../s25-table/Table";
import { TypeManagerDecorator } from "../../../../main/type.map.service";
import { Bind } from "../../../../decorators/bind.decorator";
import { S25PricingUtil } from "../../s25.pricing.util";
import { S25PricingStore } from "../../s25.pricing.store";

@TypeManagerDecorator("s25-ng-pricing-occurrences")
@Component({
    selector: "s25-ng-pricing-occurrences",
    template: `@if (init) {
        <div class="res-table" [class.occ-line-items]="data.occData.occLineItemAmounts">
            <s25-ng-table [dataSource]="tableConfig" [pivotThresholdColumn]="null"></s25-ng-table>
        </div>
    }`,
    styles: `
        :host ::ng-deep .s25ngTable {
            margin-right: unset;
            margin-left: 5px;
        }

        :host ::ng-deep .s25-ng-table--table tbody tr:nth-last-child(3) {
            border-top: unset !important;
        }

        :host ::ng-deep .s25-ng-table--table tbody tr:nth-last-child(3) > td {
            padding-top: 0.5em !important;
        }

        :host ::ng-deep .s25-ng-table--table tbody tr:nth-last-child(4) > td {
            padding-bottom: 0.5em !important;
        }

        :host ::ng-deep .s25-ng-table--table tbody tr:nth-last-child(4),
        :host ::ng-deep .s25-ng-table--table tbody tr:nth-last-child(5) {
            border-top: none !important;
        }

        :host ::ng-deep .s25-ng-table--table tbody tr:nth-last-child(2) td[data-label="List Price"] {
            vertical-align: middle;
        }

        :host ::ng-deep .s25-ng-table--table .tableHeader {
            visibility: collapse;
        }

        :host ::ng-deep .res-table {
            box-shadow:
                inset 0px 11px 8px -10px #ccc,
                inset 0px -11px 8px -10px #ccc;
        }

        :host ::ng-deep s25-ng-table {
            --color--table-contrast-row: transparent;
        }
    `,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class S25PricingOccurrencesComponent implements OnInit {
    @Input() data: any;

    private pricingStore = inject(S25PricingStore);

    init: boolean;
    tableConfig: Table.DataSource;

    constructor(private cd: ChangeDetectorRef) {}

    ngOnInit() {
        if (!this.data.occData.occLineItemAmounts) {
            this.data.occData.reservations?.map((occ: PricingOccurrence) => (occ.listPrice ??= 0));
            this.data.occData.isOccurrence = true;
        }

        this.initTableConfig();

        this.init = true;
        this.cd.detectChanges();
    }

    initTableConfig() {
        if (this.data.occData.occLineItemAmounts) this.data.rowFunc = this.occLineItemRowFunc;
        const promise = new Promise((resolve, _) => {
            const data = [...this.data.rowFunc(this.data.occData)];

            resolve(data);
        });

        const getData = async () => {
            const data: any = await promise;

            return {
                rows: data.map(this.data.mapToRows),
            };
        };

        this.tableConfig = {
            type: "unpaginated",
            dataSource: getData,
            columns: this.data.columns,
        };
    }

    @Bind
    occLineItemRowFunc() {
        const { listItems, combineRelatedEvents } = this.data.occData;
        const locatorMap = this.pricingStore.locatorMap();
        return listItems.map((item: LineItem & { taxTotal: number }) => {
            return {
                row: [
                    ...(combineRelatedEvents ? [locatorMap[item.eventId]] : []),
                    item.itemName,
                    "",
                    S25PricingUtil.formatCurrency(item.adjustmentAmt),
                    "",
                    S25PricingUtil.formatCurrency(item.taxTotal),
                    item.adjustmentAmt + item.taxTotal,
                    ...Array(5).fill(""),
                ],
                expandableFooter: true,
            };
        });
    }
}
